import React from "react";
import PropTypes from "prop-types";
import "../../components/pageHeader.scss";
import HeaderBgImg from "../../images/bg1.jpg";
import { motion } from "framer-motion";
import { ParallaxBanner } from "react-scroll-parallax";
import { formatDate } from "../../ThemeModule";

const titleVariants = {
  hidden: { opacity: 0, y: -100 },
  visible: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -100 },
};

const BlogSinglePageHeader = ({ title, post }) => {
  return (
    <>
      <ParallaxBanner
        layers={[{ image: HeaderBgImg, speed: -20 }]}
        className="page-header blog_single_page-header"
      >
        <div className="max-w-container mx-auto px-4 pt-24">
          <div className="flex-wrap flex justify-center  -mx-6">
            <div className="w-full md:w-10/12 px-6">
              <div className="text-left text-white">
                {post?.categories && (
                  <div className="post-categories">
                    {post.categories.map((category) => (
                      <span key={category.name} className="post-category">
                        {category.name}
                      </span>
                    ))}
                  </div>
                )}
                <motion.h1
                  variants={titleVariants}
                  initial="hidden"
                  animate="visible"
                  exit="exit"
                  transition={{ type: "spring", duration: 1 }}
                  className="font-medium"
                >
                  {title}
                </motion.h1>
                <div className="topInfo_wrp">
                  <div className="left_tb">
                    <div className="topInfo_author">
                      <div className="flex items-center">
                        <div className="authorImg rounded-full flex-shrink-0">
                          {post?.author?.profileImage?.url && (
                            <img
                              src={post.author.profileImage.url}
                              alt={post.author.title}
                            />
                          )}
                        </div>
                        <div className="ml-5">
                          <label>Author</label>
                          {post?.author?.title && <h6>{post.author.title}</h6>}
                        </div>
                      </div>
                    </div>
                    <div className="topInfo_date">
                      <div className="topInfo_date_inner">
                        <label>Published</label>
                        {post?.publishedAt && (
                          <h6>{formatDate(post.publishedAt)}</h6>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="right_tb"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="page_header_overlay"></div>
      </ParallaxBanner>
    </>
  );
};

BlogSinglePageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  post: PropTypes.shape({
    categories: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
      })
    ),
    author: PropTypes.shape({
      profileImage: PropTypes.shape({
        url: PropTypes.string,
      }),
      name: PropTypes.string,
    }),
    publishedAt: PropTypes.string,
  }),
};

export default BlogSinglePageHeader;
